package com.xtream.data_kmp.dto



import com.xtream.data_kmp.db.utils.tryFormat
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonTransformingSerializer


@Serializable(with = InfoSerializer::class)
abstract class InfoBase{
  abstract  val audio: Audio?
    @Serializable(UnwrappingJsonListSerializer::class)
    abstract  val backdrop_path: List<String>?
  abstract  val bitrate: Int?
  abstract  val name: String?
  abstract  val cast: String?
  abstract  val director: String?
  abstract  val duration: String?
  abstract  val duration_secs: Int?
  abstract  val genre: String?
  abstract  val movie_image: String?
  abstract  val mpaa: String?
  abstract  val plot: String?
  abstract  val rating: String?
  abstract  val releaseDate: String?
  abstract  val tmdb_id: String?
  abstract  val video: Video?
  abstract  val year: String?
    @SerialName("youtube_trailer")
  abstract  val youtubeTrailer: String?

    fun formattedRating()=
        rating?.tryFormat(
           /* locale = Locale.ENGLISH,
            "%.1f",*/
            alt = "$rating"
        ) ?: ""

}

    @Serializable

    
data class Audio(
        val avg_frame_rate: String?=null,
        val bit_rate: String?=null,
        val bits_per_sample: Int?=null,
        val channel_layout: String?=null,
        val channels: Int?=null,
        val codec_long_name: String?=null,
        val codec_name: String?=null,
        val codec_tag: String?=null,
        val codec_tag_string: String?=null,
        val codec_time_base: String?=null,
        val codec_type: String?=null,
        val disposition: Disposition?=null,
        val duration: String?=null,
        val duration_ts: Int?=null,
        val index: Int?=null,
        val max_bit_rate: String?=null,
        val nb_frames: String?=null,
        val profile: String?=null,
        val r_frame_rate: String?=null,
        val sample_fmt: String?=null,
        val sample_rate: String?=null,
        val start_pts: Int?=null,
        val start_time: String?=null,
        val tags: Tags?=null,
        val time_base: String?=null
    ){
        @Serializable

        
data class Disposition(
            val attached_pic: Int?=null,
            val clean_effects: Int?=null,
            val comment: Int?=null,
            val default: Int?=null,
            val dub: Int?=null,
            val forced: Int?=null,
            val hearing_impaired: Int?=null,
            val karaoke: Int?=null,
            val lyrics: Int?=null,
            val original: Int?=null,
            val timed_thumbnails: Int?=null,
            val visual_impaired: Int?=null
        )
    }

    @Serializable
    
data class Video(
        val avg_frame_rate: String?=null,
        val bit_rate: String?=null,
        val bits_per_raw_sample: String?=null,
        val chroma_location: String?=null,
        val codec_long_name: String?=null,
        val codec_name: String?=null,
        val codec_tag: String?=null,
        val codec_tag_string: String?=null,
        val codec_time_base: String?=null,
        val codec_type: String?=null,
        val coded_height: Int?=null,
        val coded_width: Int?=null,
       // val color_primaries: String?=null,
        //val color_range: String?=null,
        //val color_space: String?=null,
       // val color_transfer: String?=null,
        val display_aspect_ratio: String?=null,
        val disposition: Audio.Disposition?=null,
        val duration: String?=null,
        val duration_ts: Int?=null,
        val has_b_frames: Int?=null,
        val height: Int?=null,
        val index: Int?=null,
        val is_avc: String?=null,
        val level: Int?=null,
        val nal_length_size: String?=null,
        val nb_frames: String?=null,
        val pix_fmt: String?=null,
        val profile: String?=null,
        val r_frame_rate: String?=null,
        val refs: Int?=null,
        val sample_aspect_ratio: String?=null,
        val start_pts: Int?=null,
        val start_time: String?=null,
        val tags: Tags?=null,
        val time_base: String?=null,
        val width: Int?=null
    )
    @Serializable

    
data class Tags(
        val handler_name: String?=null,
        val language: String?=null
    )

object UnwrappingJsonListSerializer :
    JsonTransformingSerializer<List<String>>(ListSerializer(String.serializer())) {
    override fun transformDeserialize(element: JsonElement): JsonArray {
        if (element is JsonArray) return element
        return JsonArray(listOf())
    }
}
